<template>
    <button @click="e => $emit('click', e.target.click)">
        <svg xmlns="http://www.w3.org/2000/svg" width="68.489" height="31.42" viewBox="0 0 68.489 31.42">
            <g id="Groupe_168" data-name="Groupe 168" transform="translate(-4995.31 -4705.2)">
                <g id="Groupe_164" data-name="Groupe 164" transform="translate(5007.851 4705.2)">
                    <path
                        id="Tracé_241"
                        data-name="Tracé 241"
                        d="M196.79,44.916h3.773l1.454,5.646,1.444-5.646h3.768v9.279h-2.348V47.119l-1.811,7.075h-2.126l-1.8-7.075v7.075h-2.35Z"
                        transform="translate(-196.79 -44.916)"
                        fill="#fff"
                    />
                    <path
                        id="Tracé_242"
                        data-name="Tracé 242"
                        d="M210.294,44.916h2.861v5.527A4.65,4.65,0,0,1,212.9,52a3.351,3.351,0,0,1-.8,1.278,3.228,3.228,0,0,1-1.15.769,5.812,5.812,0,0,1-2.006.309,12.772,12.772,0,0,1-1.477-.094,3.9,3.9,0,0,1-1.339-.376,3.39,3.39,0,0,1-.984-.8,2.961,2.961,0,0,1-.611-1.07,5.527,5.527,0,0,1-.266-1.569V44.916h2.861v5.661a1.614,1.614,0,0,0,.422,1.185,1.81,1.81,0,0,0,2.328.007,1.612,1.612,0,0,0,.422-1.191Z"
                        transform="translate(-191.986 -44.916)"
                        fill="#fff"
                    />
                    <path
                        id="Tracé_243"
                        data-name="Tracé 243"
                        d="M210.829,44.916h2.866v6.993h4.478v2.286h-7.343Z"
                        transform="translate(-187.761 -44.916)"
                        fill="#fff"
                    />
                    <path
                        id="Tracé_244"
                        data-name="Tracé 244"
                        d="M215.293,44.916h8.715v2.292h-2.923v6.987h-2.867V47.208h-2.925Z"
                        transform="translate(-184.891 -44.916)"
                        fill="#fff"
                    />
                    <path
                        id="Tracé_245"
                        data-name="Tracé 245"
                        d="M221.457,44.916h2.875v9.279h-2.875Z"
                        transform="translate(-180.926 -44.916)"
                        fill="#fff"
                    />
                </g>
                <g id="Groupe_165" data-name="Groupe 165" transform="translate(4995.31 4717.509)">
                    <path
                        id="Tracé_246"
                        data-name="Tracé 246"
                        d="M223.583,64.5v6.49H206.117V52.637h9.432V64.5Z"
                        transform="translate(-178.25 -52.259)"
                        fill="#fff"
                    />
                    <path
                        id="Tracé_247"
                        data-name="Tracé 247"
                        d="M239.336,64.927a5.929,5.929,0,0,1-2.859,5c-1.922,1.216-3.96,1.594-8.166,1.594a50.454,50.454,0,0,1-10.187-.937V65.552a63.415,63.415,0,0,0,10.269.887c.822,0,1.265-.279,1.265-.838,0-.46-.312-.624-1.3-.624h-1.545c-.739,0-2.382-.115-3.467-.214a6.116,6.116,0,0,1-4.634-2.1,5.518,5.518,0,0,1-1.084-3.516A5.807,5.807,0,0,1,219.8,54.3c1.627-1.2,4.88-1.89,9.136-1.89a51.622,51.622,0,0,1,9.678.9V58.7a65.344,65.344,0,0,0-7.394-.624h-2.054c-1.265,0-1.758.246-1.758.822,0,.46.378.739,1,.739l3.3.033a14.425,14.425,0,0,1,4.732.69A4.748,4.748,0,0,1,239.336,64.927Z"
                        transform="translate(-170.851 -52.407)"
                        fill="#fff"
                    />
                    <path
                        id="Tracé_248"
                        data-name="Tracé 248"
                        d="M208.957,62.111l6.326,8.873H204.964L202.483,66.7l-2.744,4.289H189.42l6.408-8.873-6.671-9.464h11.025l2.3,4.913,2.481-4.913h10.729Z"
                        transform="translate(-189.157 -52.253)"
                        fill="#fff"
                    />
                </g>
            </g>
        </svg>
    </button>
</template>
<script>
export default {};
</script>
<style scoped lang="scss">
button {
    border: none;
    display: inline-block;
    background-color: #919192;
    padding: 5px 5px 1px;
    border-radius: 5px;
    transition: 0.3s ease-in-out;
    cursor: pointer;
    &:hover {
        box-shadow: 0 0 11px rgba(0, 0, 0, 0.3);
    }
    svg {
        height: 22px;
    }
}
</style>



// WEBPACK FOOTER //
// ForecastMultiXlsIcon.vue?3f1fc3a3